import { axiosInstance } from './api';

/**
 * On-demand JPEG snapshot from a camera via the jetson (issue #34 part 2).
 *
 * Mirrors ``services/plugins/equipment_discovery/api/snapshot.py``.
 * Returns a Blob so the FE can swap an Object URL into ``<img>`` for
 * the ~1 fps live preview in the camera detail dialog. Auth happens
 * via the standard axios JWT interceptor; the BE then re-uses
 * ``probe_http`` to route the ISAPI ``/Streaming/channels/<ch>/picture``
 * call through the jetson.
 */
export const getCameraSnapshot = (cameraId: number | string) =>
  axiosInstance.get<Blob>(
    `/equipment_discovery/cameras/${cameraId}/snapshot/`,
    { responseType: 'blob' },
  );
